import { useSpring, animated, config } from '@react-spring/web';
import './styles.css';

function DommusLogoLoading({ transparentBackground = false }) {
  const [styles, api] = useSpring(() => ({
    from: { scale: 1, shadow: 10 },
    to: async (next) => {
      while (true) {
        await next({ scale: 1.08, shadow: 40 });
        await next({ scale: 1, shadow: 10 });
      }
    },
    config: config.easeInOut,
  }));

  return (
    <div
      className="loading-container"
      style={{
        backgroundColor: transparentBackground
          ? 'rgba(0, 0, 0, 0.7)'
          : 'rgba(24, 59, 100, 1)',
      }}
    >
      <animated.div
        className="neon-border"
        style={{
          transform: styles.scale.to((s) => `scale(${s})`),
          boxShadow: styles.shadow.to(
            (s) => `0 0 ${s}px #ffffff, 0 0 ${s / 2}px #ffffff`
          ),
        }}
      >
        <div className="logo-container">
          <img src="/logo.jpeg" alt="Logo" className="logo" />
        </div>
      </animated.div>
    </div>
  );
}

export default DommusLogoLoading;
